/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NestedInPrimitiveString: core.serialization.ObjectSchema<
    serializers.NestedInPrimitiveString.Raw,
    Truvity.NestedInPrimitiveString
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace NestedInPrimitiveString {
    export interface Raw {
        values: string[];
    }
}
